// extracted by mini-css-extract-plugin
module.exports = {"title":"InvestmentProfile_title__q4E9w"};